import intermind from '../../../index';
import { ListConfig, ListParams, ListResponse } from '../../../types';
import { UserInfo } from '../../auth/types/user.types';

export class AdminUserResource {
  async listConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get<ListConfig>('/admin/users/list-config');
    return data;
  }

  async list(params: ListParams): Promise<ListResponse<UserInfo>> {
    const { data } = await intermind.httpClient.get<ListResponse<UserInfo>>('/admin/users', {
      params,
    });
    return data;
  }

  async get(userId: string): Promise<UserInfo> {
    const { data } = await intermind.httpClient.get<UserInfo>(`/admin/users/${userId}`);
    return data;
  }

  async grantAdmin(userId: string): Promise<void> {
    await intermind.httpClient.put(`/admin/users/${userId}/roles/admin`);
  }

  async revokeAdmin(userId: string): Promise<void> {
    await intermind.httpClient.delete(`/admin/users/${userId}/roles/admin`);
  }

  async delete(userId: string): Promise<void> {
    await intermind.httpClient.delete(`/admin/users/${userId}`);
  }
}
